import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import T from 'i18n';
import styles from '../CaseIntelligencePage.module.scss';

const NoAccessBanner: React.FC = () => {
  return (
    <div className={styles.noAccessBanner}>
      <LockOutlinedIcon style={{ fontSize: 36, marginBottom: 8, color: '#94a3b8' }} />
      <p>{T.translate('caseIntelligence.noAccess')}</p>
    </div>
  );
};

export default NoAccessBanner;
